import { RootState } from '@/store/main';
import { FeatureFlagMap, FeatureFlagsEnum } from './types';

export const selectFeatureFlags = (state: RootState): FeatureFlagMap => state.featureFlags.featureFlags;
export const selectFeatureFlag =
  (flag: FeatureFlagsEnum) =>
  (state: RootState): boolean =>
    !!state.featureFlags.featureFlags[flag];
export const selectLoadingFlags = (state: RootState): boolean => state.featureFlags.loading;
export const selectSeriesEnabled = selectFeatureFlag(FeatureFlagsEnum.series);
export const selectAiEmailEnabled = selectFeatureFlag(FeatureFlagsEnum.ai_email);
export const selectInPersonAutoFill = selectFeatureFlag(FeatureFlagsEnum.in_person_auto_fill);
